$shm_hitalama_dragtree_item $shm_hitalama_draglist_item
	transition_smooth \top 0.2s, left 0.2s, right 0.2s
	hold_delay 0
	hold_move_threshold 10
	buttons /number
		0
	Drag $shm_hitalama_dragtree_drag
		use_buttons <= buttons
		on_drag_start? <=> on_drag_start? null
		on_drag_end? <=> on_drag_end? null
		on_drag? <=> on_drag? null
		dragged => dragged
		y? <=> y? 0
		x? <=> x? 0
		drags_synced <= drags_synced /$rise_drag
		repos_x* <= repos_x* 1
		repos_y* <= repos_y* 1
		pointerdown? => pointerdown?
		hold_delay <= hold_delay
		hold_move_threshold <= hold_move_threshold
